import React, { ReactNode, FormEvent } from 'react';

import ErrorPanel from '#/components/basic/panels/ErrorPanel';

type Props = {
  onSubmit?: (event: Event | FormEvent) => void;
  errorMessage?: string | null;
  children?: ReactNode;
};

export default function AuthFormRaw({
  onSubmit,
  errorMessage,
  children,
}: Props) {
  return (
    <form onSubmit={onSubmit} style={{ background: 'none' }}>
      {errorMessage && <ErrorPanel message={errorMessage} marginBottom />}
      {children}
    </form>
  );
}
